import React from "react";

import Styles from "./Contacts.module.css";

const Contacts = (props) => {
 
  return (
    <div className={Styles["Contacts"]}>
      <div className="row">
        <div className={`col-xs-12 ${Styles["title"]}`}><p>{props.subSite}</p></div>
        <div className={`col-xs-12 ${Styles["text"]}`}><p>{props.address}</p></div>
        <div className={`col-xs-12 ${Styles["text"]}`}><p>{props.zipCode}</p></div>
        <div className={`col-xs-12 ${Styles["text"]}`}><p>{props.city}</p></div>
        <div className={`col-xs-12 ${Styles["subtitle"]}`}><p>{props.contactTitle}</p></div>
        <div className={`col-xs-12 ${Styles["text"]}`}><p>Telefone: {props.phone}</p></div>
        <div className={`col-xs-12 ${Styles["text"]}`}><p>Email: {props.email}</p></div>
      </div>
    </div>
  );
};

export default Contacts;
